angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsClassLeaderboard', function ( $log, EventManager, language, $sce, userAccount, DEV_VARIABLES, TeacherDataService, cordovaMessenger, PlatformService) {return {
    templateUrl: 'template.html',
    scope: {
      selectedClass: '='
    },
    link: function(scope) {
      
      var eventManager = new EventManager('teacherStudentsClassLeaderboard', scope);

      scope.getTranslation = function(slug){
        return language.get(slug);
      }
      scope.lang_adjust = function(num){
        return language.getCurrentSelectedLanguage() === 'en' ? num : num.replace('.',',');
      }

      var init = function (){
        $log.log('selectedClass >>> ', scope.selectedClass);
        var lang = language.getCurrentSelectedLanguage();
        var resource_id
        if(TeacherDataService.currentActiveMeta){
          resource_id = TeacherDataService.currentActiveMeta.resource_id
        }else{          
          var urlParams = new window.URLSearchParams(window.location.hash.split('&amp;').join('&'));      
          resource_id = Number(urlParams.get('module_id'))
        }
        const country = getCountryLeaderboard(scope.selectedClass.country);
        let iframeURl = `https://demo.mathematic.org/teacher/leaderboards/district/${country}`;
        iframeURl += `/foreignClassType/${getForeignClassType(resource_id)}`;
        iframeURl += `/foreignClassId/${getForeignClassId()}`;
        iframeURl += `/foreignId/${getForeignUid()}`;
        iframeURl += `/displayName/${encodeURIComponent(getDisplayName())}/${lang}`;

        if (TeacherDataService.getUserSchools().$$state.value.length === 1){
          if(TeacherDataService.getUserSchools().$$state.value[0].name.toLowerCase().includes('baqa')){
            scope.is_baqa = true
          }
        }
        scope.iframeUrl = $sce.trustAsResourceUrl(iframeURl);
      }

      var getForeignClassType = function(resourceId){
        var classType = 'no_class'; // default
        $log.log('getForeignClassType', resourceId);
        DEV_VARIABLES.GROUPS.LUXEMBOURG.AVAILABLE_MODULES.forEach(moduleCollection => {
          if(moduleCollection.resource_id === resourceId){
            classType = moduleCollection.foreign_slug;
          }
        })
        return classType;
      }

      var getForeignClassId = function(){
        return scope.selectedClass.id;
      }
   
      var getForeignUid = function(){
        return userAccount.getData().user_id;
      }
      var getDisplayName = function(){
        return userAccount.getData().fullName;
      }

      /**
       * Please refer to groups.groupType == 'country' in the db for what country names its expecting
       * If updating this, please update the one in mtic2\src\components\dashboards\student\student-leaderboard\index.js as well :/
       * @param {string} country
       * @returns {string}
       */
      var getCountryLeaderboard = (country) => {
        const countryLowerCase = (country || '').toLowerCase();
        switch (countryLowerCase) {
          case 'testing': return 'testing';
          case 'israel': return 'baqa';
          default: return 'luxembourg';
        }
      }

      init();

    }
}})
